import React from 'react';
import { Tooltip, TooltipProps } from 'recharts';
export type ChartConfig = Record<string, {
  label: string;
  color: string;
}>;
interface ChartContainerProps extends React.HTMLAttributes<HTMLDivElement> {
  config: ChartConfig;
  children: React.ReactNode;
}
export function ChartContainer({
  config,
  children,
  className,
  ...props
}: ChartContainerProps) {
  const style: React.CSSProperties = {};
  // Create CSS variables for each chart item
  Object.entries(config).forEach(([key, value]) => {
    style[`--color-${key}`] = value.color;
  });
  return <div className={className} style={style} {...props} data-id="element-179">
      {children}
    </div>;
}
interface ChartTooltipContentProps {
  active?: boolean;
  payload?: Array<{
    name: string;
    value: number;
    payload: Record<string, any>;
  }>;
  label?: string;
  indicator?: 'line' | 'dashed';
}
export function ChartTooltipContent({
  active,
  payload,
  label,
  indicator = 'line'
}: ChartTooltipContentProps) {
  if (!active || !payload?.length) return null;
  return <div className="rounded-lg border bg-background p-2 shadow-sm" data-id="element-180">
      <div className="grid gap-2" data-id="element-181">
        <div className="flex items-center justify-between gap-2" data-id="element-182">
          <div className="text-sm font-medium" data-id="element-183">{label}</div>
        </div>
        <div className="grid gap-1" data-id="element-184">
          {payload.map(item => <div key={item.name} className="flex items-center gap-2" data-id="element-185">
              <div className="h-1 w-1 rounded-full" style={{
            background: `var(--color-${item.name})`
          }} data-id="element-186" />
              <div className="flex items-center gap-1 text-sm" data-id="element-187">
                <div data-id="element-188">{item.value} days</div>
                <div className="text-muted-foreground" data-id="element-189">{item.name}</div>
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}
export function ChartTooltip(props: TooltipProps<any, any>) {
  return <Tooltip {...props} wrapperStyle={{
    outline: 'none'
  }} data-id="element-190" />;
}